import { loadExperimentationGroupsWithMetricWriteEpicReducer, createMetricSetEpicReducer, loadMetricSetsEpicReducer, loadMetricSetDraftsEpicReducer, loadMetricSetDraftRawColumnsEpicReducer, loadMetricSetDraftAggregationLevelsEpicReducer, loadMetricSetDraftExperimentationConfigEpicReducer, loadMetricSetDraftMetadataEpicReducer, createMetricSetDraftEpicReducer, deleteMetricSetEpicReducer, deleteMetricSetDraftEpicReducer, cloneMetricSetEpicReducer, loadWorkspaceConfigEpicReducer, loadMetricSetConfigEpicReducer, ACTION_TYPES, mergeMetricSetDraftEpicReducer, validateMetricSetDraftEpicReducer, getValidateResultEpicReducer, loadProductionMetaDataEpicReducer, loadProductionHistoryEpicReducer, loadMetricSetDraftHistoryEpicReducer, loadScorecardLayoutsEpicReducer, loadMetricHealthResultsEpicReducer, publishMetricSetDraftEpicReducer, loadPublishStatusEpicReducer, loadPublishedVersionsEpicReducer, loadRecentPreviewAnalysisEpicReducer, loadRecentFeaturesEpicReducer, loadRecentExperimentsEpicReducer, deleteSegmentEpicReducer, loadSegmentsEpicReducer, loadComputationFilePathsEpicReducer, loadColumnsEpicReducer, createSegmentEpicReducer, putComputationsEpicReducer, loadSelectedSegmentEpicReducer, loadAllExperimentationGroupsEpicReducer, loadFeaturesForExperimentationGroupEpicReducer, loadExperimentsForExperimentationGroupEpicReducer, loadExperimentEpicReducer, loadFeatureProgressionsEpicReducer, loadMetricSetMainAggregationLevelsEpicReducer, loadComputationTemplatesEpicReducer, METRICS_REDUCER_KEYS, loadComputationTemplateInstancesEpicReducer, loadMetricsForCompuatationTemplateInstancesEpicReducer, createMetricSetInstanceEpicReducer, loadMetricSetInstanceStatusEpicReducer, updateMetricSetConfigEpicReducer, loadExperimentStepPlanSummariesEpicReducer, validateExperimentStepsEpicReducer, loadDefaultExperimentsEpicReducer, loadDefaultFeaturesEpicReducer, loadMetricsEpicReducer, loadColumnDetailsEpicReducer, updateMergeStatusMetricSetDraftEpicReducer, updatePublishStatusMetricSetDraftEpicReducer, checkUserMetricWriteAccessEpicReducer, } from './Vivace.epics';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { ACTION_TYPES as MetricActionTypes, createMetricEpicReducer, createComutationTemplateInstanceEpicReducer, loadMetricDetailsEpicReducer, putComputationsWithUpdatesEpicReducer, loadQuickValidationResultEpicReducer, checkQuickValidateEpicReducer, putComputationsWithAdditionalUpdatesEpicReducer, getScorecardLayoutPathsEpicReducer, getNewTemplateInstancesEpicReducer, getMetricsInNewTemplateInstanceEpicReducer, getScorecardLayoutsEpicReducer, putScorecardLayoutFilesEpicReducer, quickCompileEpicReducer, quickComputeEpicReducer, cancelQuickValidationEpicReducer, loadDraftDatasourceEpicReducer, loadDatasourceDetailsEpicReducer, } from './Metric/Metric.epics';
export const getDefaultState = () => ({
    global: {
        experimentation_groups_with_metric_write: getDefaultAsyncWrapperObj(),
        experimentation_groups: getDefaultAsyncWrapperObj(),
        user_access: {},
        user_metric_write_access: {},
    },
    metric_sets: {
        list: getDefaultAsyncWrapperObj(),
        create: getDefaultAsyncWrapperObj(),
        clone: getDefaultAsyncWrapperObj(),
        delete: getDefaultAsyncWrapperObj(),
        workspace_config: getDefaultAsyncWrapperObj(),
        metric_set_instance_create: getDefaultAsyncWrapperObj(),
        metric_set_instance_status: getDefaultAsyncWrapperObj(),
    },
    drafts: {
        meta_data: getDefaultAsyncWrapperObj(),
        history: getDefaultAsyncWrapperObj(),
        list: getDefaultAsyncWrapperObj(),
        create: getDefaultAsyncWrapperObj(),
        delete: getDefaultAsyncWrapperObj(),
        metric_set_config: getDefaultAsyncWrapperObj(),
        metric_set_config_update: getDefaultAsyncWrapperObj(),
        aggregation_levels: getDefaultAsyncWrapperObj(),
    },
    draft: {
        history: getDefaultAsyncWrapperObj(),
        raw_columns: getDefaultAsyncWrapperObj(),
        aggregation_levels: getDefaultAsyncWrapperObj(),
        experiment_config: getDefaultAsyncWrapperObj(),
        meta_data: getDefaultAsyncWrapperObj(),
        scorecard_layouts: getDefaultAsyncWrapperObj(),
        computation_templates: getDefaultAsyncWrapperObj(),
        computation_template_instances: getDefaultAsyncWrapperObj(),
        computation_template_instance_metrics: getDefaultAsyncWrapperObj(),
        scorecard_layout_paths: {},
        merge: getDefaultAsyncWrapperObj(),
        merge_update: getDefaultAsyncWrapperObj(),
        validate: getDefaultAsyncWrapperObj(),
        validate_result: getDefaultAsyncWrapperObj(),
        metrics: {
            user_context: {
                metric: null,
                query: null,
            },
            metric_wizard: {
                metadata: null,
                metric_details: getDefaultAsyncWrapperObj(),
                create_get: getDefaultAsyncWrapperObj(),
                create_put: getDefaultAsyncWrapperObj(),
                quick_compile_put: getDefaultAsyncWrapperObj(),
                quick_compute_put: getDefaultAsyncWrapperObj(),
                quick_compute_get: getDefaultAsyncWrapperObj(),
                quick_compute_cancel: getDefaultAsyncWrapperObj(),
                quick_compute_check: getDefaultAsyncWrapperObj(),
                custom_dimensions: {},
                datasource_get: getDefaultAsyncWrapperObj(),
                datasource_details_get: getDefaultAsyncWrapperObj(),
            },
            list: getDefaultAsyncWrapperObj(),
        },
        metric_health: {
            stat_sig_check: getDefaultAsyncWrapperObj(),
        },
        publish: getDefaultAsyncWrapperObj(),
        publish_update: getDefaultAsyncWrapperObj(),
        publish_status: getDefaultAsyncWrapperObj(),
        published_versions: getDefaultAsyncWrapperObj(),
        recent_preview_analyses: getDefaultAsyncWrapperObj(),
        experiment: getDefaultAsyncWrapperObj(),
        recent_experiments: getDefaultAsyncWrapperObj(),
        feature_progressions: getDefaultAsyncWrapperObj(),
        recent_features: getDefaultAsyncWrapperObj(),
        default_experiments: getDefaultAsyncWrapperObj(),
        default_features: getDefaultAsyncWrapperObj(),
        experimentation_group_features: getDefaultAsyncWrapperObj(),
        experimentation_group_experiments: getDefaultAsyncWrapperObj(),
        experiment_plan_summaries: getDefaultAsyncWrapperObj(),
        experiment_steps_validate_result: getDefaultAsyncWrapperObj(),
        segments: {
            list: getDefaultAsyncWrapperObj(),
            load: getDefaultAsyncWrapperObj(),
            create_get: getDefaultAsyncWrapperObj(),
            create_put: getDefaultAsyncWrapperObj(),
            delete: getDefaultAsyncWrapperObj(),
        },
        computation_file_paths: getDefaultAsyncWrapperObj(),
        columns: {
            list: getDefaultAsyncWrapperObj(),
            load: getDefaultAsyncWrapperObj(),
        },
    },
});
export const MauiReducer = (state = getDefaultState(), 
/**
 * TODO redux cleanup
 * Typescript should be able to infer the type within based on the switch statement
 */
actionResult) => {
    var _a, _b, _c, _d, _e, _f, _g;
    state = checkUserMetricWriteAccessEpicReducer.reduxChange(state, actionResult);
    state = loadExperimentationGroupsWithMetricWriteEpicReducer.reduxChange(state, actionResult);
    state = loadAllExperimentationGroupsEpicReducer.reduxChange(state, actionResult);
    state = createMetricSetEpicReducer.reduxChange(state, actionResult);
    state = createMetricSetInstanceEpicReducer.reduxChange(state, actionResult);
    state = cloneMetricSetEpicReducer.reduxChange(state, actionResult);
    state = deleteMetricSetEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetsEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetInstanceStatusEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetDraftsEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetDraftHistoryEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetDraftRawColumnsEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetDraftAggregationLevelsEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetDraftExperimentationConfigEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetDraftMetadataEpicReducer.reduxChange(state, actionResult);
    state = loadProductionHistoryEpicReducer.reduxChange(state, actionResult);
    state = loadProductionMetaDataEpicReducer.reduxChange(state, actionResult);
    state = loadScorecardLayoutsEpicReducer.reduxChange(state, actionResult);
    state = loadComputationTemplatesEpicReducer.reduxChange(state, actionResult);
    state = loadComputationTemplateInstancesEpicReducer.reduxChange(state, actionResult);
    state = loadMetricsForCompuatationTemplateInstancesEpicReducer.reduxChange(state, actionResult);
    state = createMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    state = deleteMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    state = mergeMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    state = validateMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    state = getValidateResultEpicReducer.reduxChange(state, actionResult);
    state = publishMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    state = loadPublishStatusEpicReducer.reduxChange(state, actionResult);
    state = loadMetricHealthResultsEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetConfigEpicReducer.reduxChange(state, actionResult);
    state = updateMetricSetConfigEpicReducer.reduxChange(state, actionResult);
    state = loadMetricSetMainAggregationLevelsEpicReducer.reduxChange(state, actionResult);
    state = loadWorkspaceConfigEpicReducer.reduxChange(state, actionResult);
    state = deleteSegmentEpicReducer.reduxChange(state, actionResult);
    state = loadSegmentsEpicReducer.reduxChange(state, actionResult);
    state = loadComputationFilePathsEpicReducer.reduxChange(state, actionResult);
    state = loadColumnsEpicReducer.reduxChange(state, actionResult);
    state = loadMetricsEpicReducer.reduxChange(state, actionResult);
    state = createSegmentEpicReducer.reduxChange(state, actionResult);
    state = loadPublishedVersionsEpicReducer.reduxChange(state, actionResult);
    state = loadRecentPreviewAnalysisEpicReducer.reduxChange(state, actionResult);
    state = loadExperimentEpicReducer.reduxChange(state, actionResult);
    state = loadRecentExperimentsEpicReducer.reduxChange(state, actionResult);
    state = loadFeatureProgressionsEpicReducer.reduxChange(state, actionResult);
    state = loadRecentFeaturesEpicReducer.reduxChange(state, actionResult);
    state = loadDefaultExperimentsEpicReducer.reduxChange(state, actionResult);
    state = loadDefaultFeaturesEpicReducer.reduxChange(state, actionResult);
    state = loadFeaturesForExperimentationGroupEpicReducer.reduxChange(state, actionResult);
    state = loadExperimentsForExperimentationGroupEpicReducer.reduxChange(state, actionResult);
    state = putComputationsEpicReducer.reduxChange(state, actionResult);
    state = loadSelectedSegmentEpicReducer.reduxChange(state, actionResult);
    state = loadMetricDetailsEpicReducer.reduxChange(state, actionResult);
    state = putComputationsWithUpdatesEpicReducer.reduxChange(state, actionResult);
    state = getNewTemplateInstancesEpicReducer.reduxChange(state, actionResult);
    state = putComputationsWithAdditionalUpdatesEpicReducer.reduxChange(state, actionResult);
    state = getMetricsInNewTemplateInstanceEpicReducer.reduxChange(state, actionResult);
    state = getScorecardLayoutPathsEpicReducer.reduxChange(state, actionResult);
    state = getScorecardLayoutsEpicReducer.reduxChange(state, actionResult);
    state = putScorecardLayoutFilesEpicReducer.reduxChange(state, actionResult);
    state = createMetricEpicReducer.reduxChange(state, actionResult);
    state = createComutationTemplateInstanceEpicReducer.reduxChange(state, actionResult);
    state = quickCompileEpicReducer.reduxChange(state, actionResult);
    state = quickComputeEpicReducer.reduxChange(state, actionResult);
    state = loadQuickValidationResultEpicReducer.reduxChange(state, actionResult);
    state = cancelQuickValidationEpicReducer.reduxChange(state, actionResult);
    state = checkQuickValidateEpicReducer.reduxChange(state, actionResult);
    state = loadDraftDatasourceEpicReducer.reduxChange(state, actionResult);
    state = loadDatasourceDetailsEpicReducer.reduxChange(state, actionResult);
    state = loadExperimentStepPlanSummariesEpicReducer.reduxChange(state, actionResult);
    state = validateExperimentStepsEpicReducer.reduxChange(state, actionResult);
    state = loadColumnDetailsEpicReducer.reduxChange(state, actionResult);
    state = updateMergeStatusMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    state = updatePublishStatusMetricSetDraftEpicReducer.reduxChange(state, actionResult);
    switch (actionResult.type) {
        /**
         * Metric sets
         */
        case ACTION_TYPES.METRIC_SETS.RESET_CREATE:
            return Object.assign(Object.assign({}, state), { metric_sets: Object.assign(Object.assign({}, state.metric_sets), { create: getDefaultAsyncWrapperObj(), metric_set_instance_create: getDefaultAsyncWrapperObj(), metric_set_instance_status: getDefaultAsyncWrapperObj() }) });
        case ACTION_TYPES.METRIC_SETS.RESET_DELETE:
            return Object.assign(Object.assign({}, state), { metric_sets: Object.assign(Object.assign({}, state.metric_sets), { delete: getDefaultAsyncWrapperObj() }) });
        case ACTION_TYPES.METRIC_SETS.RESET_CLONE:
            return Object.assign(Object.assign({}, state), { metric_sets: Object.assign(Object.assign({}, state.metric_sets), { clone: getDefaultAsyncWrapperObj() }) });
        case ACTION_TYPES.METRIC_SETS.REMOVE:
            {
                const data = (_a = state.metric_sets.list) === null || _a === void 0 ? void 0 : _a.data;
                if (data) {
                    const index = data === null || data === void 0 ? void 0 : data.findIndex((item) => item.metricSet === actionResult.payload);
                    return Object.assign(Object.assign({}, state), { metric_sets: Object.assign(Object.assign({}, state.metric_sets), { list: Object.assign(Object.assign({}, state.metric_sets.list), { data: [...data.slice(0, index), ...data.slice(index + 1)] }) }) });
                }
            }
            break;
        /**
         * Drafts
         */
        case ACTION_TYPES.DRAFTS.RESET_META_DATA:
            {
                const data = (_b = state.drafts.meta_data) === null || _b === void 0 ? void 0 : _b.data;
                if (data) {
                    return Object.assign(Object.assign({}, state), { drafts: Object.assign(Object.assign({}, state.drafts), { meta_data: getDefaultAsyncWrapperObj() }) });
                }
            }
            break;
        case ACTION_TYPES.DRAFTS.RESET_HISTORY:
            {
                const data = (_c = state.drafts.history) === null || _c === void 0 ? void 0 : _c.data;
                if (data) {
                    return Object.assign(Object.assign({}, state), { drafts: Object.assign(Object.assign({}, state.drafts), { history: getDefaultAsyncWrapperObj() }) });
                }
            }
            break;
        case ACTION_TYPES.DRAFTS.RESET_CREATE:
            return Object.assign(Object.assign({}, state), { drafts: Object.assign(Object.assign({}, state.drafts), { create: getDefaultAsyncWrapperObj() }) });
        case ACTION_TYPES.DRAFTS.RESET_DELETE:
            return Object.assign(Object.assign({}, state), { drafts: Object.assign(Object.assign({}, state.drafts), { delete: getDefaultAsyncWrapperObj() }) });
        case ACTION_TYPES.DRAFTS.REMOVE:
            {
                const data = (_d = state.drafts.list) === null || _d === void 0 ? void 0 : _d.data;
                if (data) {
                    const index = data === null || data === void 0 ? void 0 : data.findIndex((item) => item.version === actionResult.payload);
                    return Object.assign(Object.assign({}, state), { drafts: Object.assign(Object.assign({}, state.drafts), { list: Object.assign(Object.assign({}, state.drafts.list), { data: [...data.slice(0, index), ...data.slice(index + 1)] }) }) });
                }
            }
            break;
        /**
         * Draft
         */
        case ACTION_TYPES.DRAFT.RESET_MERGE: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { merge: getDefaultAsyncWrapperObj() }) });
        }
        case ACTION_TYPES.DRAFT.RESET_HISTORY: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { history: getDefaultAsyncWrapperObj() }) });
        }
        case ACTION_TYPES.DRAFT.RESET_VALIDATE: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { validate: getDefaultAsyncWrapperObj(), validate_result: getDefaultAsyncWrapperObj() }) });
        }
        case ACTION_TYPES.DRAFT.RESET_PUBLISH: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { publish: getDefaultAsyncWrapperObj(), publish_status: getDefaultAsyncWrapperObj() }) });
        }
        /**
         * Segments
         */
        case ACTION_TYPES.DRAFT.SEGMENTS_RESET_DELETE: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { segments: Object.assign(Object.assign({}, state.draft.segments), { delete: getDefaultAsyncWrapperObj() }) }) });
        }
        case ACTION_TYPES.DRAFT.SEGMENTS_REMOVE:
            {
                const data = (_e = state.draft.segments.list) === null || _e === void 0 ? void 0 : _e.data;
                if (data) {
                    const filteredData = data === null || data === void 0 ? void 0 : data.map((s) => ({ i: s.i, filePath: s.filePath })).filter((s) => actionResult.payload.filter((f) => f.name === s.i['@Name'] && f.filePath === s.filePath && f.level === s.i['@Level']).length === 0);
                    return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { segments: Object.assign(Object.assign({}, state.draft.segments), { list: Object.assign(Object.assign({}, state.draft.segments.list), { data: filteredData }) }) }) });
                }
            }
            break;
        case ACTION_TYPES.DRAFT.SEGMENTS_RESET_CREATE: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { segments: Object.assign(Object.assign({}, state.draft.segments), { create_get: getDefaultAsyncWrapperObj(), create_put: getDefaultAsyncWrapperObj(), load: getDefaultAsyncWrapperObj() }), columns: Object.assign(Object.assign({}, state.draft.columns), { load: getDefaultAsyncWrapperObj() }) }) });
        }
        case ACTION_TYPES.DRAFT.SEGMENTS_ADD: {
            const data = (_f = state.draft.segments.list) === null || _f === void 0 ? void 0 : _f.data;
            if (data) {
                data.push(actionResult.payload);
                return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { segments: Object.assign(Object.assign({}, state.draft.segments), { list: Object.assign(Object.assign({}, state.draft.segments.list), { data: data }) }) }) });
            }
            break;
        }
        /**
         * Metrics
         */
        case MetricActionTypes.METRIC_METADATA_SET: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { metadata: actionResult.payload }) }) }) });
        }
        case MetricActionTypes.METRIC_METADATA_RESET: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { metadata: null }) }) }) });
        }
        case MetricActionTypes.METRIC_DETAILS_RESET: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { metric_details: getDefaultAsyncWrapperObj() }) }) }) });
        }
        case MetricActionTypes.METRIC_RESET_CREATE: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { [METRICS_REDUCER_KEYS.create_get]: getDefaultAsyncWrapperObj(), [METRICS_REDUCER_KEYS.create_put]: getDefaultAsyncWrapperObj(), metric_details: getDefaultAsyncWrapperObj(), quick_compile_put: getDefaultAsyncWrapperObj(), quick_compute_put: getDefaultAsyncWrapperObj(), quick_compute_get: getDefaultAsyncWrapperObj(), quick_compute_check: getDefaultAsyncWrapperObj(), quick_compute_cancel: getDefaultAsyncWrapperObj(), datasource_get: getDefaultAsyncWrapperObj(), datasource_details_get: getDefaultAsyncWrapperObj(), metadata: null, custom_dimensions: {} }) }) }) });
        }
        case MetricActionTypes.METRIC_QUICK_VALIDATE_RESET: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { quick_compute_get: getDefaultAsyncWrapperObj() }) }) }) });
        }
        case MetricActionTypes.CUSTOM_DIM_SET_ALL: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { custom_dimensions: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard.custom_dimensions), actionResult.payload) }) }) }) });
        }
        case MetricActionTypes.CUSTOM_DIM_SET: {
            return Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { custom_dimensions: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard.custom_dimensions), { [actionResult.payload.id]: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard.custom_dimensions[actionResult.payload.id]), actionResult.payload.customDimension) }) }) }) }) });
        }
        case MetricActionTypes.CUSTOM_DIM_SET_USE: {
            const id = actionResult.payload.id;
            const component = actionResult.payload.component;
            const currentCustomDim = (_g = state.draft.metrics.metric_wizard.custom_dimensions[id]) === null || _g === void 0 ? void 0 : _g[component];
            const newCustomDim = { [actionResult.payload.component]: Object.assign(Object.assign({}, currentCustomDim), { inUse: actionResult.payload.inUse }) };
            return !currentCustomDim
                ? state // don't set custom dimension if it doesn't aleady exist in state
                : Object.assign(Object.assign({}, state), { draft: Object.assign(Object.assign({}, state.draft), { metrics: Object.assign(Object.assign({}, state.draft.metrics), { metric_wizard: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard), { custom_dimensions: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard.custom_dimensions), { [actionResult.payload.id]: Object.assign(Object.assign({}, state.draft.metrics.metric_wizard.custom_dimensions[actionResult.payload.id]), newCustomDim) }) }) }) }) });
        }
    }
    return state;
};

//# sourceMappingURL=MauiReducer.js.map
